import React from 'react';
import clsx from 'clsx';

import styles from './SlidingPanel.module.scss';
import FloatingToggleButton from './FloatingToggleButton';
import Icon from './Icon';

export default function SlidingPanel({
	show,
	variant = 'primary',
	onClose,
	className,
	...rest
}) {
	return (
		<div
			className={clsx(
				styles.root,
				show && styles.show,
				variant && styles[variant],
				className && className
			)}
		>
			<FloatingToggleButton
				className={styles.closeButton}
				show={true}
				onClick={onClose}
				enabled={true}
				icon={
					<Icon
						icon={
							variant === 'primary'
								? 'icon/close_white.png'
								: 'icon/close_blue.png'
						}
						size="small"
					/>
				}
				right={'10px'}
				top={'10px'}
			/>

			{rest.children}
		</div>
	);
}
